import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

function getUserRolesHelper(teamId: number, userId: number) {
  return clientApi.getOCClient().helpers.employer.teams.id(teamId).users.id(userId).roles;
}

type RoleUpdated = {
  name: 'team-admin';
  startedAt?: string;
  endedAt?: string;
};

const { useUpdate: useTeamUserRolesUpdate } = getCRUDHooks({
  entityName: 'teamUserRole',
  update: (newRoles: RoleUpdated[], { teamId, userId }: { teamId: number; userId: number }) =>
    getUserRolesHelper(teamId, userId).partialUpdate('', newRoles),
});

// eslint-disable-next-line import/prefer-default-export
export { useTeamUserRolesUpdate };
